import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import Masonry from "react-masonry-css";
import { Context } from "../../Context/ContextApi";
import ProductSkeleton from "./ProductSkeleton";

const Products = () => {
  const { homeProducts, loading } = useContext(Context);

  const homeProductsData = useMemo(
    () => homeProducts?.data?.products ?? [],
    [homeProducts]
  );

  const breakpointColumnsObj = {
    default: 4,
    1200: 3,
    768: 2,
    576: 1,
  };

  return (
    <div className="product-section py-5">
      <div className="container">

        <h1 className="text-center text-white mb-4">
          Purchase Now: Your Online Destination for Exquisite Paintings
        </h1>

        {/* Show Skeleton on first load */}
        {loading || !homeProductsData.length ? (
          <ProductSkeleton />
        ) : (
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {homeProductsData.map((item) => (
              <div key={item.id} className="masonry-item mt-4">
                <div className="card h-100 shadow-sm">
                  <a className="text-decoration-none text-dark" href={`/painting/${item.product_url}`}>
                    <img
                      src={item.product_image_url}
                      alt={item.product_name}
                      className="card-img-top"
                      loading="lazy"
                    />
                  </a>
                  <div className="card-body">
                    <h5 className="card-title text-dark">
                      <a className="text-decoration-none text-dark" href={`/painting/${item.product_url}`}>
                        {item.product_name}
                      </a>

                    </h5>

                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0 text-dark">
                        <strong>Size:</strong> {item.product_size}
                      </p>

                      <p className="mb-0 fw-bold" style={{ color: "#cc9051" }}>
                        ₹{Number(item.product_price).toLocaleString("en-IN")}
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </Masonry>
        )}

        <div className="text-center mt-4">
          <Link to="/shop">
            <button className="btn btn-outline-light bg-dark">
              View All Paintings
            </button>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Products;
